export class DateTimeStyle {
    public static CUSTOM: string = "custom";
    public static NONE: string = "none";
    public static SHORT: string = "short";
    public static MEDIUM: string = "medium";
    public static LONG: string = "long";
    public static FULL: string = "full";
}
